/**
 * Licensed Materials - Property of IBM
 * IBM Business Analytics (C) Copyright IBM Corp. 2020
 * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 */

/**
 * @class ContentMenuAPI
 * @hideconstructor
 * @classdesc API class that is used to obtain the list of content menu available
 */
define([], () => {
	class ContentMenuAPI {

		/**
		 * @function ContentMenuAPI#registerProvider
		 * @description Register a provider as a content menu provider
		 * @param {String} name of the provider
		 * @param {Object} provider Provider api that registers and contributes to content menu
		 * eg. usage: registerProvider('overlay', overlay.getAPI());
		 */
		registerProvider() {}

		/**
		 * @function ContentMenuAPI#getContentMenuList
		 * @description Returns a list of content menu available for a specific item given a list of content ids.
		 * @param {string[]} idList list of content ids
		 * @return {object[]} array containing all available menu
		 * eg. [{
		 * 	id: 'id1',
		 * 	name: 'overlay',
		 * 	label: 'show/hide overlay',
		 * 	action: actionFunction
		 * }]
		 */
		getContentMenuList( /* idList */ ) {}

	}

	return ContentMenuAPI;
});